import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { HttpService } from '../../../service/http.service';
import { GlobalService } from '../../../service/global.service';
import { CommonModule } from '@angular/common';
import { NgxStarsModule } from 'ngx-stars';
import { FormsModule } from '@angular/forms';
import { LoginComponent } from '../../../modals/login/login.component';
import { ActiveToast, ToastrService } from 'ngx-toastr';
import { ProductCheckoutComponent } from '../product-checkout/product-checkout.component';
import { ProductOrderPaymentComponent } from '../product-order-payment/product-order-payment.component';
import { OrderSuccessComponent } from '../../../modals/order-success/order-success.component';
import { MoreServicesComponent } from '../more-services/more-services.component';
import { ServicePlanComponent } from "../service-plan/service-plan.component";
import { TdsSolutionComponent } from "../tds-solution/tds-solution.component";
import { CustomerSaysComponent } from "../../customer-says/customer-says.component";
declare let $: any;
declare var Swiper: any
@Component({
  selector: 'app-product-detail',
  standalone: true,
  imports: [
    CommonModule,
    NgxStarsModule,
    LoginComponent,
    ProductCheckoutComponent,
    ProductOrderPaymentComponent,
    RouterModule,
    FormsModule,
    OrderSuccessComponent,
    MoreServicesComponent,
    ServicePlanComponent,
    TdsSolutionComponent,
    CustomerSaysComponent
  ],
  templateUrl: './product-detail.component.html',
  styleUrl: './product-detail.component.css'
})
export class ProductDetailComponent implements OnInit {
  productDetails: any = {};
  slug: any;
  openCheckoutPage: boolean = false;
  openPaymentPage: boolean = false;
  openLoginFlag: boolean = false;
  productUrl: any;
  index: any = 0;
  userId: any;

  totalWalletAmount: any = 0;

  onlinePuja = "Browse more pujas";

  loginPopuptype: string = 'login'

  isLoginPopup: boolean = false;
  isOrderSuccess: boolean = false;


  thumnailSwiperData: Array<any> = [];



  constructor(private _homeService: HttpService,
    private toastr: ToastrService,
    private router: Router,
    private _router: ActivatedRoute,
    injector: Injector,
    private titleService: Title,
    private metaService: Meta,
    public gS: GlobalService) {
    this.userId = this.gS.userData?.id;
  }

  async ngOnInit() {
    this.getUserWalletAmount();
    // this.productUrl = this._router.snapshot.params['id'];

    this._router.params.subscribe(params => {
      this.productUrl = params['id'];
      this.isLoginPopup = false;
      this.openCheckoutPage = false;
      this.openLoginFlag = false;
      this.isOrderSuccess = false;
      this.openPaymentPage = false;
      this.getData();
    });


    await this.getProductData().then((res: any) => {
      console.log(res, "product_data");
      setTimeout(() => {
        this.initMoreServiceSwiper();
      }, 0);
    });
  }

  getData() {
    this._homeService.getproductDetails(this.gS.timeZone, this.productUrl).subscribe(
      (data: any) => {
        if (data?.data) {
          this.productDetails = data?.data;
          console.log(this.productDetails, 'productDetails');

          this.slug = this.productDetails?.productTypeSlug;
          localStorage.removeItem("ap-astro-puja-detail");
          localStorage.setItem("ap-astro-puja-detail", JSON.stringify(this.productDetails));

          const seoTitle = this.productDetails?.seoTitle || 'Default Title';
          const seoDescription = this.productDetails?.seoDes || 'Default Description';
          const canonicalUrl = window.location.href;

          this.update_htmlconfig(seoTitle, seoDescription, canonicalUrl);

          if (this.productDetails) {
            this.thumnailSwiperData = [this.productDetails?.productImage, ...this.productDetails?.moreImages];
            setTimeout(() => {
              this.initThumbnailSwiper();
            }, 0);
          }
        }
      }, (error) => {
        console.log(error);
      });
  }

  handleInvalidProduct(): void {
    this.toastr.error(
      'This product details are not available.',
      'Oops',
      { timeOut: 3000 }
    );
    this.router.navigate(['/puja-list'], { replaceUrl: true });
  }

  openLoginPopup(login: string) {
    this.isLoginPopup = true;
    this.loginPopuptype = login;
  }

  closeLoginPopup() {
    this.isLoginPopup = false;
  }

  private isClosingFromOverlay = false;

  onOverlayClick() {
    this.isClosingFromOverlay = true;
    this.closePopup();
  }

  openCheckout(item: any) {
    // if (this.isClosingFromOverlay) {
    //   this.isClosingFromOverlay = false;
    //   return;
    // }
    this.productDetails = item;
    this.openPaymentPage = false;
    document.body.classList.add('checkout-opening');
    this.openCheckoutPage = true;
    document.body.style.overflow = 'hidden';
  }

  getUserWalletAmount() {
    this._homeService.getUserWalletAmount(this.gS.customerId, 0).subscribe((data) => {
      let value: any = data;
      this.totalWalletAmount = value.availableBalance;
      console.log(this.totalWalletAmount);
    }, (error) => {
      console.log(error);
    });

  }

  closePopup(event?: any) {
    this.isLoginPopup = false;
    this.openCheckoutPage = false;
    this.openLoginFlag = false;
    this.isOrderSuccess = false;
    this.openPaymentPage = false;

    document.body.style.overflow = '';
  }

  eventCheckoutSuccess(event: any) {
    this.openCheckoutPage = false;
    this.openPaymentPage = true;
  }

  paymentSuccess(event: any) {
    this.openCheckoutPage = false;
    this.openPaymentPage = false;
    this.isOrderSuccess = true;
  }

  closeOrderSuccessPopup(event: any) {
    this.isOrderSuccess = false;
    if (event == 'history') {
      this.router.navigate(['/customer-product-order-history']);
    }
  }

  initThumbnailSwiper() {
    var thumbnailSwiperThumb = new Swiper(".thumbnailSwiperThumb", {
      spaceBetween: 10,
      slidesPerView: 4,
      watchSlidesProgress: true,
      loop: this.thumnailSwiperData.length > 4,
    });
    var thumbnailSwiperMain = new Swiper(".thumbnailSwiperMain", {
      spaceBetween: 10,
      grabCursor: true,
      effect: "creative",
      creativeEffect: {
        prev: {
          shadow: true,
          translate: [0, 0, -400],
        },
        next: {
          translate: ["100%", 0, 0],
        },
      },
      loop: this.thumnailSwiperData.length > 4,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: thumbnailSwiperThumb,
      },
    });
  }

  initMoreServiceSwiper() {
    var swiper = new Swiper(".moreServiceSwiper", {
      // slidesPerView: 4,
      spaceBetween: 16,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      on: {
        init: () => {
          const swiperEl = document.getElementById('more_services');
          swiperEl?.classList.remove('swiper-wrapper-hidden');
        }
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 4,
        },
      },
    });
  }

  productData: Array<any> = [];

  getProductData() {
    return new Promise<Array<any>>((resolve) => {
      this._homeService.getAllProductsByCategory(this.gS.userData?.id ? this.gS.userData?.id : 0).subscribe((data: any) => {
        if (data?.data) {
          let response = data?.data?.pageData;
          if (response) {
            this.productData = response.flatMap((item: any) => item?.productList);
          }
        }
        resolve(this.productData);
      }, (error) => {
        console.log(error);
      });
    })
  }

  navigateToProduct(item: any) {
    this.openCheckoutPage = false;
    this.openPaymentPage = false;
    this.router.navigate(['/products', item?.productTypeSlug, item?.productUrl]);
  }

  contactUs() {
    if (this.userId) {
      this.gS.navigate('/support-chat')
    } else {
      this.openLoginPopup('login')
    }

  }

  update_htmlconfig(title: string, metadescription: string, conancialtag: string) {
    if (title && title !== '') {
      this.titleService.setTitle(title);
    }
    if (metadescription && metadescription !== '') {
      this.metaService.updateTag({
        name: 'description',
        content: metadescription,
      })
    }
    if (conancialtag && conancialtag !== '') {

      let canonicalTag = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
      if (canonicalTag) {
        canonicalTag.setAttribute('href', conancialtag);
      } else {
        canonicalTag = document.createElement('link');
        canonicalTag.setAttribute('rel', 'canonical');
        canonicalTag.setAttribute('href', conancialtag);
        document.head.appendChild(canonicalTag);
      }
    }
  }

  get isItrProduct(): boolean {
    return this.slug === 'tax-and-compliance';
  }

}
